import { hotRanking } from "@/mocks/home";

function rankStyle(rank: number) {
  if (rank === 1) return "text-primary-500";
  if (rank <= 3) return "text-accent-600";
  return "text-foreground-300";
}

function barStyle(rank: number) {
  if (rank === 1) return "bg-primary-500";
  if (rank <= 3) return "bg-accent-500";
  return "bg-secondary-400";
}

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-20 md:px-8 md:py-32">
        <div className="mb-12 flex flex-col gap-4 md:mb-16 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-label text-xs tracking-[0.3em] text-primary-500 md:text-sm">
              WEEKLY CHART
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              本周热度榜
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            根据近七日的访问量与线路稳定度综合排序，帮你优先挑选人气更高、更抗压的入口。
          </p>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200">
          {hotRanking.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 border-b border-background-200 bg-background-100 px-4 py-5 last:border-b-0 md:gap-8 md:px-8 md:py-7"
            >
              <span
                className={`w-10 shrink-0 font-heading text-3xl font-black leading-none md:w-14 md:text-5xl ${rankStyle(
                  item.rank
                )}`}
              >
                {String(item.rank).padStart(2, "0")}
              </span>

              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.name}
                </h3>
                <p className="mt-1 truncate font-label text-xs text-foreground-500 md:text-sm">
                  {item.host}
                </p>
              </div>

              <div className="hidden w-40 shrink-0 md:block lg:w-56">
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-300">
                  <div
                    className={`h-full rounded-full ${barStyle(item.rank)}`}
                    style={{ width: `${item.heat}%` }}
                  ></div>
                </div>
                <p className="mt-2 font-label text-xs text-foreground-500">热度 {item.heat}</p>
              </div>

              <div className="w-20 shrink-0 text-right md:w-28">
                <p className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.visits}
                </p>
                <p
                  className={`mt-1 font-label text-xs md:text-sm ${
                    item.trend.startsWith("+") ? "text-accent-600" : "text-primary-500"
                  }`}
                >
                  {item.trend}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 font-label text-xs text-foreground-500 md:text-sm">
          数据为站内统计的相对热度，仅用于辅助选择入口，不代表任何外部排名。
        </p>
      </div>
    </section>
  );
}